import 'backbone-model-composite';
import Backbone from 'backbone';
import _ from "underscore-contrib";
import md5 from "md5";
import config from '../../configure.json';

const ModelComposite = (Backbone as any).ModelComposite as typeof Backbone.Model;
type SortOfSyncOpts = { attrs?: any, success: (attrs: any) => void, error: (model?: Backbone.Model, response?: Response) => void }

export default ModelComposite.extend({

   urlRoot: function () {
      return "/news-api/lists/" + this.listId + "/members"
   },

   urlTagRoot: function () {
      return "/news-api/lists/" + this.listId + "/members/" + this.get('id') + "/tags";
   },

   // https://github.com/samolsen/backbone-model-composite
   childModels: {
      interests: Backbone.Model,
      tags: Backbone.Model,
   },

   defaults: {
      "email_address": "",
      "status": "subscribed",
   },

   subscriberExists: false,

   initialize: function (attributes, options) {
      this.listId = options && options.listId;

      this.listenTo(this, 'change:email_address', (model, value) => {
         this.set('id', md5(value.trim().toLowerCase()))
      });
      this.listenTo(this, 'sync', (model) => {
         model.subscriberExists = true // Need to know for unsubscribe
      }
      );
   },

   // https://stackoverflow.com/questions/46155/how-to-validate-email-address-in-javascript
   validEmailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

   validate: function (attributes) {
      if (!this.validEmailRegex.test(attributes.email_address)) {
         return true;
      }
   },

   _buildTags: function (tags: Record<string, boolean>) {
      return Object.entries(tags).reduce((result, [tagName, isChecked]) => {
         result.push({ name: tagName, status: isChecked ? 'active' : 'inactive' });
         return result;
      }, [] as { name: string, status: 'active' | 'inactive' }[]);
   },

   sync: async function (method: 'read' | 'create' | 'update', model: Backbone.Model, options: SortOfSyncOpts) {
      if (method === 'read') {
         return Backbone.sync.apply(this, arguments);
      } 
      const attrs = options.attrs || model.toJSON(options);
      const memberResp = await fetch(`${this.urlRoot()}/${this.id}`, { method: 'PUT', body: JSON.stringify({ ...attrs, tags: undefined }) });
      if (!memberResp.ok) {
         options.error && options.error(model, memberResp);
         return
      }
      const member = await memberResp.json();

      const tagsUrl = this.urlTagRoot();
      const tags = this._buildTags(attrs.tags);
      const resp = await fetch(tagsUrl, { method: 'POST', body: JSON.stringify({ tags }) });
      if (!resp.ok) {
         options.error && options.error(model, resp);
         return  
      }
      options.success && options.success({ ...member, tags: attrs.tags });
   },

   set: function (key, val, options) {
      Backbone.Model.prototype.set.apply(this, arguments);
      // Handle both `"key", value` and `{key: value}` -style arguments.
      let attrs;
      if (typeof key === 'object') {
         attrs = key;
         options = val;
      }
      else {
         (attrs = {})[key] = val;
      }

      if (!options || !options.excludeChildModels) {
         _.each(_.keys(_.result(this, 'childModels')), function (key) {
            attrs[key] && this[key].set(attrs[key], options)
         }, this);
      }
      return this
   },

   // **parse** converts a response into the hash of attributes to be `set` on  the model.
   parse: function (resp, options) {
      if (resp.status && resp.status !== 'subscribed') {
         resp.interests = _.mapObject(resp.interests, () => {
            return false
         });
      }
      if (Array.isArray(resp?.tags)) {
         
         const allTags = getListTags(this.listId, config);

         resp.tags = allTags.reduce((result, tagName) => {
            result[tagName] = resp.tags?.find((t) => t.name === tagName) ? true : false;
            return result;
         }, {} as Record<string, boolean>);
      }

      return resp;
   },

});

function getListTags(listId: string, conf: typeof config): string[] {
   const listConfig = Object.values(conf).find(
      (value) => value?.public?.listId === listId
   );
   return _.flatten(_.walk.pluckRec(listConfig, "tags"));
}
